import { ArrowLeft, ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

interface StepShellProps {
	title: string;
	description: string;
	children: ReactNode;
	onBack?: () => void;
	onContinue?: () => void;
	continueLabel?: string;
	continueDisabled?: boolean;
	formId?: string;
	onSkip?: () => void;
	skipLabel?: string;
}

export function StepShell({
	title,
	description,
	children,
	onBack,
	onContinue,
	continueLabel = "Continuar",
	continueDisabled = false,
	formId,
	onSkip,
	skipLabel = "Pular esta etapa",
}: StepShellProps) {
	return (
		<Card>
			<CardHeader>
				<CardTitle className="step-shell__title">{title}</CardTitle>
				<CardDescription>{description}</CardDescription>
			</CardHeader>
			<CardContent className="step-shell__body">{children}</CardContent>
			<CardFooter className="step-shell__footer">
				{onBack ? (
					<Button
						type="button"
						variant="ghost"
						className="step-shell__back"
						onClick={onBack}
					>
						<ArrowLeft /> Voltar
					</Button>
				) : (
					<span />
				)}
				<div className="step-shell__nav">
					{onSkip && (
						<Button type="button" variant="ghost" onClick={onSkip}>
							{skipLabel}
						</Button>
					)}
					<Button
						type={formId ? "submit" : "button"}
						form={formId}
						onClick={formId ? undefined : onContinue}
						disabled={continueDisabled}
					>
						{continueLabel} <ArrowRight />
					</Button>
				</div>
			</CardFooter>
		</Card>
	);
}
